import { Status } from './status.model';

export class StatusResponse {
  statuses: Status[];

  constructor(statuses: any) {
    this.statuses = statuses;
  }
}
